import { getCountryDataList } from 'countries-list';

type CountryType = {
  value: string;
  label: string;
};

export type GetCountriesListReturnType = CountryType[];

export const getCountriesList = (): GetCountriesListReturnType => {
  return getCountryDataList().map((country) => ({
    value: country.iso2,
    label: country.name,
  }));
};
